import React from 'react';
import styles from 'components/button/loading-icon.module.scss';

const LoadingIcon = () => {
  return (
    <div className={styles['lds-ellipsis']}>
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export default LoadingIcon;
